import React, { useEffect, useState, useRef } from "react";
import Modal from "../../../../Components/ExtraComponents/Modal";
// import BasicDataTable from "../../../../Components/ExtraComponents/Datatable/BasicDataTable";
import { fa_time, fDateTimeSuffix } from "../../../../Utils/Date_formet";
import { GetSignalsAdmins } from "../../../../ReduxStore/Slice/Admin/TradehistorySlice";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";  


const DetailsView = ({ showModal, setshowModal, tradeHistoryData }) => {
  const ft_time = (row) => {
    if (row.ft_time != undefined) {
      var milliseconds = row.ft_time * 1000;

      // Create a new Date object with the milliseconds
      var dateObject = new Date(milliseconds);

      // Get the year, month, day, hours, minutes, and seconds
      var year = dateObject.getFullYear();
      var month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
      var day = ("0" + dateObject.getDate()).slice(-2);
      var hours = ("0" + dateObject.getHours()).slice(-2);
      var minutes = ("0" + dateObject.getMinutes()).slice(-2);
      var seconds = ("0" + dateObject.getSeconds()).slice(-2);

      // Form the date string
      var dateString =
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds +
        " (IST)";

      // Output the result

      return dateString;
      //return row.ft_time
    } else {
      return "-";
    }
  };

  const columns = [
 
  {
    name: "Symbol",
    selector: (row) => row.symbol,
    sortable: true,
    // width: "120px",
  },
  {
    name: "Exchange",
    selector: (row) => row.category,
    sortable: true,
    // width: "120px",
  },
  {
    name: "Entry Type",
    selector: (row) => row.ordertype,
    cell: (row) =>
     row.side === "LE" || row.side === "SE"  || row.side === "BUY"  ? (
        <span>{row.ordertype}</span>
      ) : (
        <span>-</span>
      ),
    sortable: true,
    // width: "120px",
  },
  {
    name: "Exit Type",
    selector: (row) => row.ordertype,
    cell: (row) =>
     row.side === "LX" || row.side === "SX"  || row.side === "SELL"  ? (
        <span>{row.ordertype}</span>
      ) : (
        <span>-</span>
      ),
    sortable: true,
    // width: "120px",
  },
  {
    name: "Qty Percentage",
    selector: (row) =>
      row.lotsize !== "" ? parseFloat(row.lotsize) : "-",
    sortable: true,
    // width: "140px",
  },
  {
    name: "Entry Price",
    selector: (row) =>
      row.side === "LE" || row.side === "SE"  || row.side === "BUY"  ? (
        parseFloat(row.price)
      ) : (
        "-"
      ),
    sortable: true,
    // width: "130px",
  },
  {
    name: "Exit Price",
    selector: (row) =>
      row.side === "LX" || row.side === "SX" || row.side === "SELL"
        ? parseFloat(row.price)
        : "-",
    sortable: true,
    // width: "130px",
  },
  {
    name: "Strategy",
    selector: (row) => row.strategy,
    sortable: true,
    // width: "130px",
  },
  {
    name: "Signal Type",
    selector: (row) => row.signalType,
    sortable: true,
    // width: "130px",
  },
  {
    name: "Signals Time",
    selector: (row) => row.createdAt,
    cell: (row) => (
      <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
    ),
    sortable: true,
    width: "180px",
  }
  
];



  return (
    <div>
      <Modal
        isOpen={showModal}
        size="xl"
        title="Trade Details"
        hideBtn={true}
        handleClose={() => setshowModal(false)}
      >
        {tradeHistoryData?.ordersData ? (

          // <BasicDataTable
          //   TableColumns={columns1}
          //   tableData={tradeHistoryData.ordersData}
          // />
          <Table
            columns={columns}
            data={tradeHistoryData?.ordersData}
          />

        ) : (

          <div className="text-center">Loading...</div>
        )}
      </Modal>
    </div>
  );
};

export default DetailsView;
